import { combineReducers } from "@reduxjs/toolkit";
import hostedPagesReducer, { BrandsState, CurrentBrandSlice, CurrentBrandState } from "./hostedpages";
import pagesReducer, { PagesState } from "./pages";
const rootReducer = combineReducers({
  Brands: hostedPagesReducer,
  CurrentBrand: CurrentBrandSlice.reducer,
  Pages: pagesReducer
});

export default rootReducer;

export interface NewHostedPagesSchema {
  Brands: BrandsState;
  CurrentBrand: CurrentBrandState;
  Pages: PagesState;
}
